import { GropedByStringKey, StringKey } from './types';
import { AuthUser } from '../contexts/AuthProvider/types';
import { MedisanteOrgReport } from '../pages/Dashboard/types';
import { Filter } from '../pages/Devices/types';

export const partial =
  (fn: (...args: any[]) => any, ...partialArgs: any[]) =>
  (...restArgs: any[]) => {
    const args = [...partialArgs, ...restArgs];
    return fn(...args);
  };

export const partialRight =
  (fn: (...args: any[]) => any, ...partialArgs: any[]) =>
  (...restArgs: any[]) => {
    const args = [...restArgs, ...partialArgs.reverse()];
    return fn(...args);
  };

/*FILTER HELPERS*/
export const onlyUnique =
  <T>(
    comparer: (item1: T, item2: T) => boolean = (item1, item2) =>
      item1 === item2
  ) =>
  (item: T, index: number, self: T[]) => {
    return self.findIndex((current) => comparer(item, current)) === index;
  };

/**/

export const isNullOrUndefined = (obj: any) =>
  obj === undefined || obj === null;

export const nullifyIfEmptyOrWhitespace = (text: any) =>
  typeof text === 'string' && text.trim() === '' ? null : text;

export const nullifyIfEmptyArray = (obj: any) => {
  if (!!obj && Array.isArray(obj) && obj.length === 0) return null;

  return obj;
};

export const groupBy = <T, K extends keyof T>(
  collection: T[],
  key: StringKey<T, K>
): GropedByStringKey<T> => {
  return collection.reduce((prev: GropedByStringKey<T>, curr: T) => {
    const newKey = curr[key as K] as unknown as string;
    return { ...prev, [newKey]: [...(prev[newKey] || []), curr] };
  }, {});
};

export const groupByValue = <T>(
  collection: T[],
  getPropValue: (entity: T) => string
): GropedByStringKey<T> => {
  return collection.reduce((prev: GropedByStringKey<T>, curr: T) => {
    const newKey = getPropValue(curr);
    return { ...prev, [newKey]: [...(prev[newKey] || []), curr] };
  }, {});
};

export const getValueByPropName = (obj: any, propName: string) => obj[propName];

export const calculateIsMaximumDevicesReached = (
  authUser: AuthUser,
  reports: MedisanteOrgReport[]
): boolean => {
  const deviceNum = reports
    .map((report) => {
      return report.deviceCount ? report.deviceCount : 0;
    })
    .reduce((a, b) => a + b, 0);
  // if selectedOrgs is 0 this mean that everything is selected
  const orgCount =
    authUser.selectedOrgs.length === 0
      ? authUser.orgs.length
      : authUser.selectedOrgs.length;
  return deviceNum > 8000 || orgCount > 89;
};

export const isTotalMeasurementCount = (): boolean => {
  return localStorage.getItem('totalMeasurementMode') === 'true';
};

export const mergeFilters = (left: Filter[], right: Filter[]): Filter[] => {
  const merged = [...left, ...right];
  const unique = merged.filter(
    (item, index) =>
      merged.findIndex(
        (i) => i.category === item.category && i.value === item.value
      ) === index
  );
  return unique;
};

export const isSelectedOrgDeactivated = (authUser: AuthUser): boolean => {
  let deactivated = 0;
  for (let org of authUser.orgs) {
    if (org.deactivated) {
      deactivated++;
    }
  }
  return deactivated === authUser.orgs.length;
};
